import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  Fragment,
  useContext,
  useMemo,
} from 'react';
import { Context } from '../../../context/AppContext';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import matchArrays from '../../../utils/matchArrays';
import { WAYS_TO_PAY_FILTER_ICONS, FILTERS } from '../../../constants';
import getParamFilterValue from '../../../utils/getParamFilterValue';
import DropDown from './DropDown';
import NavButton from './NavButton';
import CheckBox from './CheckBox';
import ApplyButton from './ApplyButton';
import './styles.css';

const rename = {
  'Certegy Ezi-Pay': 'Humm',
};

const { PAYMENT_METHODS, PAY_LATER } = FILTERS;

const WaysToPay = ({
  fetchMore,
  filters,
  filter = '',
  selectedCount,
  filtersCount,
  updateFiltersCount,
  sort,
}) => {
  const {
    media: { tablet, desktop, mobile },
  } = useContext(Context);
  const [selected, setSelected] = useState('');
  const [dirty, setDirty] = useState();
  const [dropdownFilters, setDropdownFilters] = useState([]);

  const [show, setShow] = useState();
  const ref = useRef();

  useEffect(() => {
    setSelected(filter);
    setDirty(false);
  }, [filter]);

  useEffect(() => {
    setDropdownFilters(filters);
  }, [filters]);

  const matchInitial = useMemo(() => {
    return matchArrays(
      selected ? selected.split(',').sort() : [],
      filter ? filter.split(',').sort() : []
    );
  }, [selected, filter]);

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (show) {
        setSelected(filter);
        updateFiltersCount(filter);
        setShow(false);
      }
    }, [filter, show])
  );

  const setFilter = useCallback(
    (value, add) => {
      const paramFilter = getParamFilterValue(selected, value, add);
      setSelected(paramFilter);
      updateFiltersCount(paramFilter);
      setDirty(true);
    },
    [selected]
  );

  const selectedValues = useMemo(
    () =>
      selected
        ? [...PAYMENT_METHODS, ...PAY_LATER].reduce((agg, { label, value }) => {
            if (selected.includes(value)) {
              return agg.concat(label);
            }
            return agg;
          }, [])
        : null,
    [selected]
  );

  return (
    <div className="Listview__Filters__wrapper" ref={ref}>
      {(tablet || desktop) && (
        <Fragment>
          <NavButton
            className="Listview__Filters__button--waysToPay"
            active={!!selectedCount || show}
            onClick={() => setShow(!show)}
            hasSelected={selectedCount}
          >
            Ways to Pay
          </NavButton>
          <DropDown show={show} heading="Ways to Pay">
            <div className="Listview__Filters__options">
              {show &&
                dropdownFilters &&
                !!dropdownFilters.length &&
                dropdownFilters.map(({ label, checked, value }) => (
                  <CheckBox
                    key={rename[label] || label}
                    defaultChecked={checked}
                    disabled={!filtersCount[value] && !checked}
                    value={value}
                    onClick={e => setFilter(e.target.value, e.target.checked)}
                  >
                    <i
                      className={
                        WAYS_TO_PAY_FILTER_ICONS[
                          (rename[label] || label).toLowerCase()
                        ] || WAYS_TO_PAY_FILTER_ICONS.default
                      }
                    />{' '}
                    {rename[label] || label}{' '}
                    {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                  </CheckBox>
                ))}
            </div>
            <ApplyButton
              active={dirty && !matchInitial}
              data-filter={selectedValues}
              onClick={e => {
                fetchMore(e, {
                  page: 0,
                  filter: selected,
                  sort,
                });
                setShow(false);
              }}
            >
              Apply
            </ApplyButton>
          </DropDown>
        </Fragment>
      )}
      {mobile && (
        <Fragment>
          {dropdownFilters.map(({ label, checked, value }) => (
            <Fragment key={label}>
              {checked ? (
                <NavButton
                  active={checked}
                  onClick={e => {
                    const paramFilter = getParamFilterValue(
                      selected,
                      value,
                      !checked
                    );
                    setSelected(paramFilter);
                    fetchMore(e, {
                      page: 0,
                      filter: paramFilter,
                      sort,
                    });
                  }}
                >
                  {rename[label] || label}{' '}
                  {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                </NavButton>
              ) : (
                ''
              )}
            </Fragment>
          ))}
        </Fragment>
      )}
    </div>
  );
};

export default WaysToPay;
